"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function TimeManager() {
  this.counter = 0;
  this.nextTime = null;
}

TimeManager.prototype = {
  fib: function fib(n) {
    var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    return n === 0 ? b : this.fib(n - 1, a + b, a);
  },
  isTime: function isTime() {
    var currentTime = Date.now();
    if (currentTime >= this.nextTime || !this.nextTime) {
      this.nextTime = currentTime + this.fib(++this.counter) * 1000;
      return true;
    }
    return false;
  }
};

exports.default = TimeManager;